import { Directive, Input, OnDestroy } from '@angular/core';
import { TitleService } from '../services/page-title.service';

@Directive({
  selector: '[trPageTitle]',
})
export class PageTitleDirective implements OnDestroy {
  @Input('trPageTitle') public set pageTitle(title: string) {
    this.titleService.setTitle(title);
  }

  constructor(private titleService: TitleService) {}

  public ngOnDestroy() {
    this.titleService.setTitle(null);
  }
}
